module.exports = __webpack_public_path__ + "static/media/subway.254d762f.gif";